import React, { PropsWithChildren } from 'react';
import { Box } from '@sparknz/spark-pattern-library';
import { LinkRegion } from '@sparknz/tracking';

const PromotionMessageContainer = ({ children }: PropsWithChildren<{}>) => (
  <Box pt="s3">
    <LinkRegion regionId="seeEligibleDiscounts">{children}</LinkRegion>
  </Box>
);

export default PromotionMessageContainer;
